import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { HelpersService } from 'src/app/services';
import { PaymentService } from 'src/app/services/payment.service';
import { PosIntegrationService } from 'src/app/services/pos-integration.service';
import { RentalsService } from 'src/app/services/rentals.service';

@Component({
  selector: 'app-rentals-flexible-duration-config',
  templateUrl: './rentals-flexible-duration-config.component.html',
  styleUrls: ['./rentals-flexible-duration-config.component.scss'],
})
export class RentalsFlexibleDurationConfigComponent implements OnInit {
  public partner: any = {};
  public configuaration: any = {};
  public flexibleTimeUnits: any = [];
  public RentalConfigForm: FormGroup;
  public busy: boolean = false;
  public priceGroupsDetail: any;
  public showPriceGroup: boolean = false;
  public showTimeUnitDialog: boolean = false;
  public selectedPriceGroup: any = {};
  public selectedTimeUnit: any = {};
  public loadingPriceGroupsDetail: boolean = false;
  public loadingFlexibleTimeUnits: boolean = false;
  public removingTimeUnit: boolean = false;
  public savingTimeUnit: boolean = false;
  public loadingConfig: boolean = false;
  public timeUnits: any = [{ value: 2, label: 'Day(s)' }];

  constructor(
    private fb: FormBuilder,
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private messageService: MessageService,
    private paymentService: PaymentService,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.getFlexibleRentalConfig();
    this.getFlexibleTimeUnits();
    this.getRentalPriceGroupsDetail();
  }

  getFlexibleRentalConfig() {
    this.loadingConfig = true;
    this.rentalsService
      .getRentalFlexibleConfiguration(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.configuaration = res;
          this.setupValidation();
          this.loadingConfig = false;
        },
        (err) => {
          this.loadingConfig = false;
        },
      );
  }

  getFlexibleTimeUnits() {
    this.loadingFlexibleTimeUnits = true;
    this.rentalsService
      .getRentalFlexibleTimeUnits(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.flexibleTimeUnits = res;
          this.loadingFlexibleTimeUnits = false;
        },
        (err) => {
          this.loadingFlexibleTimeUnits = false;
        },
      );
  }

  getRentalPriceGroupsDetail() {
    this.loadingPriceGroupsDetail = true;
    this.rentalsService
      .getRentalFlexiblePriceGroupsDetail(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.priceGroupsDetail = res;
          this.loadingPriceGroupsDetail = false;
        },
        (err) => {
          this.loadingPriceGroupsDetail = false;
        },
      );
  }

  setupValidation() {
    this.RentalConfigForm = this.fb.group({
      addExtraDay: new FormControl(this.configuaration.addExtraDay, [
        Validators.nullValidator,
      ]),
      minimumDurationValue: new FormControl(
        this.configuaration.minimumDurationValue,
        [Validators.required, Validators.min(0)],
      ),
      minimumDurationUnitType: new FormControl(
        this.configuaration.minimumDurationUnitType || 2,
        [Validators.nullValidator],
      ),
      disableMaximumDuration: new FormControl(
        this.configuaration.disableMaximumDuration,
        [Validators.nullValidator],
      ),
      maximumDurationValue: new FormControl(
        this.configuaration.maximumDurationValue || 10,
        [Validators.required, Validators.min(1)],
      ),
      maximumDurationUnitType: new FormControl(
        this.configuaration.maximumDurationUnitType || 2,
        [Validators.required, Validators.min(1)],
      ),
    });
  }

  closePriceGroup() {
    this.showPriceGroup = false;
  }

  addPriceGroup() {
    this.selectedPriceGroup = {
      name: '',
      description: '',
      flexibleRentalRate: this.flexibleTimeUnits.map((x) => {
        return {
          fromUnit: x.fromUnit,
          fromUnitType: x.fromUnitType,
          fromUnitTypeID: x.fromUnitTypeID,
          toUnit: x.toUnit,
          toUnitType: x.toUnitType,
          toUnitTypeID: x.toUnitTypeID,
          quantity: 1,
          flexibleTimeUnitID: x.id,
        };
      }),
      isActive: true,
      defaultPartnerID: this.helpersService.getPartnerId(),
    };
    this.showPriceGroup = true;
  }

  getUnitValue(unit) {
    var value = this.timeUnits
      .filter((x) => {
        return x.value == unit;
      })
      .pop();
    return value ? value.label : '';
  }

  editTimeUnit(timeUnit) {
    this.selectedTimeUnit = JSON.parse(JSON.stringify(timeUnit));
    this.showTimeUnitDialog = true;
  }

  addTimeUnit() {
    var gaps = this.findRuleGaps();
    this.selectedTimeUnit = {
      fromUnit:
        gaps.length > 0
          ? gaps[0].rangeStartUnit
          : this.configuaration.minimumDurationValue,
      fromUnitTypeID:
        gaps.length > 0
          ? gaps[0].rangeStartUnitType
          : this.configuaration.minimumDurationUnitType,
      toUnit:
        gaps.length > 0
          ? gaps[0].rangeEndUnit
          : this.configuaration.maximumDurationValue,
      toUnitTypeID:
        gaps.length > 0
          ? gaps[0].rangeEndUnitType
          : this.configuaration.maximumDurationUnitType,
      defaultPartnerID: this.helpersService.getPartnerId(),
    };

    //this.selectedTimeUnit = { fromUnit: this.getNextAvailableFromUnit(), fromUnitTypeID: 2, toUnit: this.getNextAvailableToUnit(), toUnitTypeID: 2, defaultPartnerID: this.helpersService.getPartnerId() };
    this.showTimeUnitDialog = true;
  }

  updatePriceGroup(priceGroup) {
    this.selectedPriceGroup = JSON.parse(JSON.stringify(priceGroup));
    this.showPriceGroup = true;
  }

  saveFlexibleTimeUnit() {
    this.savingTimeUnit = true;
    if (this.selectedTimeUnit.id) {
      this.rentalsService
        .updateRentalFlexibleTimeUnits(this.selectedTimeUnit)
        .subscribe(
          (res) => {
            this.flexibleTimeUnits = res;
            this.showTimeUnitDialog = false;
            this.savingTimeUnit = false;
            this.getRentalPriceGroupsDetail();
          },
          (err) => {
            this.showTimeUnitDialog = false;
            this.savingTimeUnit = false;
          },
        );
    } else {
      this.rentalsService
        .addRentalFlexibleTimeUnits(this.selectedTimeUnit)
        .subscribe(
          (res) => {
            this.flexibleTimeUnits = res;
            this.showTimeUnitDialog = false;
            this.savingTimeUnit = false;
            this.getRentalPriceGroupsDetail();
          },
          (err) => {
            this.showTimeUnitDialog = false;
            this.savingTimeUnit = false;
          },
        );
    }
  }

  removeFlexibleTimeUnit() {
    this.removingTimeUnit = true;
    this.rentalsService
      .updateRentalFlexibleTimeUnits({
        ...this.selectedTimeUnit,
        isActive: false,
      })
      .subscribe((res) => {
        this.flexibleTimeUnits = res;
        this.showTimeUnitDialog = false;
        this.removingTimeUnit = false;
        this.getRentalPriceGroupsDetail();
      });
  }

  saveFlexibleRentalConfig(value) {
    const data = { ...this.configuaration, ...value };
    this.busy = true;
    this.rentalsService.updateRentalFlexibleConfiguration(data).subscribe(
      (res) => {
        this.configuaration = res;
        this.busy = false;
        this.getFlexibleTimeUnits();
        this.getRentalPriceGroupsDetail();
      },
      (err) => {
        this.busy = false;
      },
    );
  }

  findRuleGaps() {
    var missingRules = [];
    var start = 0;
    var end = 0;

    for (
      var value = this.configuaration.minimumDurationValue;
      value <= this.configuaration.maximumDurationValue;
      value++
    ) {
      if (
        this.flexibleTimeUnits.filter((x) => {
          return (
            x.fromUnitTypeID === 2 &&
            x.toUnitTypeID === 2 &&
            x.toUnitTypeID === 2 &&
            value >= x.fromUnit &&
            value <= x.toUnit
          );
        }).length === 0 &&
        !start
      ) {
        start = value;
      } else if (
        this.flexibleTimeUnits.filter((x) => {
          return (
            x.fromUnitTypeID === 2 &&
            x.toUnitTypeID === 2 &&
            x.toUnitTypeID === 2 &&
            value >= x.fromUnit &&
            value <= x.toUnit
          );
        }).length > 0 &&
        start
      ) {
        end = value;
        missingRules.push({
          rangeStartUnit: start,
          rangeEndUnit: end - 1,
          rangeStartUnitType: 2,
          rangeEndUnitType: 2,
        });
        start = 0;
        end = 0;
      } else if (
        value == this.configuaration.maximumDurationValue &&
        start &&
        this.configuaration.maximumDurationUnitType == 2
      ) {
        end = value;
        missingRules.push({
          rangeStartUnit: start,
          rangeEndUnit: end,
          rangeStartUnitType: 2,
          rangeEndUnitType: 2,
        });
        start = 0;
        end = 0;
      }
    }

    return missingRules.filter(this.onlyUnique);
  }

  onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

  checkFromUnitUsed() {
    var definedValues = [];

    this.flexibleTimeUnits
      .filter((x) => {
        return (
          x.fromUnitTypeID == this.selectedTimeUnit.fromUnitTypeID &&
          x.id != this.selectedTimeUnit.id
        );
      })
      .forEach((timeUnit) => {
        for (var i = timeUnit.fromUnit; i <= timeUnit.toUnit; i++) {
          if (this.selectedTimeUnit.fromUnit === i) {
            definedValues.push(i);
          }
        }
      });

    return definedValues.indexOf(this.selectedTimeUnit.fromUnit) > -1;
  }

  checkToUnitUsed() {
    var definedValues = [];

    this.flexibleTimeUnits
      .filter((x) => {
        return (
          x.toUnitTypeID == this.selectedTimeUnit.toUnitTypeID &&
          x.id != this.selectedTimeUnit.id
        );
      })
      .forEach((timeUnit) => {
        for (var i = timeUnit.fromUnit; i <= timeUnit.toUnit; i++) {
          if (this.selectedTimeUnit.toUnit === i) {
            definedValues.push(i);
          }
        }
      });

    return definedValues.indexOf(this.selectedTimeUnit.toUnit) > -1;
  }

  isSelectedTimeUnitValid() {
    return (
      this.selectedTimeUnit.fromUnit !== null &&
      this.selectedTimeUnit.fromUnit !== undefined &&
      this.selectedTimeUnit.fromUnit >=
        this.configuaration.minimumDurationValue &&
      this.selectedTimeUnit.fromUnitTypeID &&
      this.selectedTimeUnit.fromUnitTypeID > 0 &&
      this.selectedTimeUnit.toUnit &&
      this.selectedTimeUnit.toUnit > 0 &&
      this.selectedTimeUnit.toUnitTypeID &&
      this.selectedTimeUnit.toUnitTypeID > 0 &&
      ((this.selectedTimeUnit.toUnitTypeID ===
        this.selectedTimeUnit.fromUnitTypeID &&
        this.selectedTimeUnit.toUnit >= this.selectedTimeUnit.fromUnit) ||
        this.selectedTimeUnit.toUnitTypeID >
          this.selectedTimeUnit.fromUnitTypeID) &&
      this.selectedTimeUnit.fromUnit >=
        this.configuaration.minimumDurationValue &&
      this.selectedTimeUnit.toUnit <=
        this.configuaration.maximumDurationValue &&
      !this.checkFromUnitUsed() &&
      !this.checkToUnitUsed()
    );
  }

  // getNextAvailableFromUnit() {
  //   var range = [];
  //   var definedValues = [];

  //   for (var value = this.configuaration.minimumDurationValue; value <= this.configuaration.maximumDurationValue; value++) {
  //     range.push(value);
  //   }

  //   this.flexibleTimeUnits.forEach(timeUnit => {
  //     for (var i = timeUnit.fromUnit; i <= timeUnit.toUnit; i++) {
  //       definedValues.push(i);
  //     }
  //   });
  //   var difference = range.filter(x => !definedValues.includes(x));
  //   console.log(difference);
  //   return difference.length > 0 ? difference[0] : this.configuaration.minimumDurationValue;
  // }

  // getNextAvailableToUnit() {
  //   var range = [];
  //   var definedValues = [];

  //   for (var value = this.configuaration.minimumDurationValue; value <= this.configuaration.maximumDurationValue; value++) {
  //     range.push(value);
  //   }

  //   this.flexibleTimeUnits.forEach(timeUnit => {
  //     for (var i = timeUnit.fromUnit; i <= timeUnit.toUnit; i++) {
  //       definedValues.push(i);
  //     }
  //   });
  //   var difference = range.filter(x => !definedValues.includes(x));
  //   var nextVal = 0;
  //   if(difference.length > 0){
  //     difference.forEach((x, index, difference)=>{
  //       if(x+1 !== difference[index+1] && nextVal === 0){
  //         nextVal = x;
  //       }
  //     });
  //   }

  //   return nextVal > 0 ? nextVal : this.configuaration.maximumDurationValue;
  // }
}
